import { Order } from 'commons/utils/types/dashboard-response-dto';

import { ExternalShipmentItem } from 'domains/orders/save-on-shipping/types';
import { PERPAGE_EXTERNAL_SHIPMENTS } from 'domains/orders/utils/constants';

export type ExternalShipmentState = {
  page: number;
  limit: number;
  externalDeliveryOrders?: ExternalShipmentItem[];
  migratedOrders?: Order[];
  totalSavings?: number;
};

export type Action =
  | { type: 'CHANGE_PAGINATION'; payload: number }
  | { type: 'SET_DELIVERY_ORDERS'; payload: ExternalShipmentItem[] }
  | { type: 'SET_MIGRATE_ORDERS'; payload: Order[] }
  | { type: 'TOGGLE_DELIVERY_ORDER'; payload: ExternalShipmentItem }
  | { type: 'TOGGLE_DELIVERY_ORDERS'; payload: ExternalShipmentItem[] }
  | { type: 'SET_TOTAL_SAVINGS'; payload: number }
  | { type: 'CLEAR_DELIVERY_ORDERS' };

const initialState: ExternalShipmentState = {
  page: 1,
  limit: PERPAGE_EXTERNAL_SHIPMENTS,
  externalDeliveryOrders: [],
  migratedOrders: [],
  totalSavings: 0
};

const externalShipmentReducer = (
  state: ExternalShipmentState,
  action: Action
): ExternalShipmentState => {
  switch (action.type) {
    case 'CHANGE_PAGINATION':
      return { ...state, page: action.payload };

    case 'SET_DELIVERY_ORDERS':
      return { ...state, externalDeliveryOrders: action.payload };

    case 'SET_MIGRATE_ORDERS':
      return { ...state, migratedOrders: action.payload };

    case 'SET_TOTAL_SAVINGS':
      return { ...state, totalSavings: action.payload };

    case 'TOGGLE_DELIVERY_ORDER': {
      const selected = state.externalDeliveryOrders ?? [];

      return {
        ...state,
        externalDeliveryOrders: selected.some(
          (item) => item.id === action.payload.id
        )
          ? selected.filter((item) => item.id !== action.payload.id)
          : [...selected, action.payload]
      };
    }

    case 'TOGGLE_DELIVERY_ORDERS': {
      const selected = state.externalDeliveryOrders ?? [];
      const isSelected = (item: ExternalShipmentItem) =>
        selected.some((current) => current.id === item.id);

      if (action.payload.every(isSelected)) {
        const payloadIds = new Set(action.payload.map((item) => item.id));

        return {
          ...state,
          externalDeliveryOrders: selected.filter(
            (current) => !payloadIds.has(current.id)
          )
        };
      }

      return {
        ...state,
        externalDeliveryOrders: [
          ...selected,
          ...action.payload.filter((item) => !isSelected(item))
        ]
      };
    }

    case 'CLEAR_DELIVERY_ORDERS':
      return { ...state, externalDeliveryOrders: [] };

    default:
      return state;
  }
};

export { initialState, externalShipmentReducer };
